export const importConstants = {
    AND: 'and',
    AVAILABLE_FOR_DOWNLOAD: 'available for download.',
    CANCEL_BUTTON: 'Cancel',
    CONFIRM_IMPORT_BUTTON: 'Confirm Import',
    CONTINUE_BUTTON: 'Continue',
    DECIMAL_LABEL: 'Ratio (0.00 - 1.00)',
    DO_NOT_IMPORT: 'Do not import',
    DUPLICATE_QUICK_SELECT_FRICTION_CONTENT: 'This action will overwrite your current selections. Do you want to continue?',
    DUPLICATE_QUICK_SELECT_FRICTION_HEADER: 'Confirm overwrite',
    DUPLICATE_QUICK_SELECT_OPTIONS: {
        FIRST: 'Keep all first record occurrences',
        LAST: 'Keep all last record occurrences',
        MANUAL: 'Review each record and choose which occurrence to keep',
    },
    DUPLICATE_QUICK_SELECT_TITLE: 'Choose resolution',
    DUPLICATE_RECORDS_TITLE: 'Review duplicate records',
    ERR_FILE_SIZE_EXCEED_LIMIT: 'Current size limit for a file is {0} MB. You can reduce the file size by splitting the data into' +
        ' smaller parts and/or remove sheets that are not needed (Excel only).',
    ERR_HEADERS: {
        CANNOT_CANCEL: 'Unable to cancel import',
        CANNOT_FIND_STAGING_DATA: 'Cannot find import staging data',
        CANNOT_LOAD_DATASHEETS: 'Cannot load datasheet(s)',
        CANNOT_LOAD_DEDUP_SELECTIONS: 'Cannot load deduplicate selections',
        CANNOT_LOAD_HEADER_MAPPINGS: 'Cannot load header mappings',
        CANNOT_LOAD_PREVIEW: 'Cannot load preview data',
        CANNOT_MOVE_NEXT: 'Cannot move to next step',
        CANNOT_MOVE_PREVIOUS: 'Cannot move to previous step',
        CANNOT_START_IMPORT: 'Unable to start import',
        CANNOT_UPLOAD_FILE: 'Cannot upload file',
    },
    ERR_MISSING_UOM: 'Please map the unit of measurement of the following field(s): ',
    ERR_UNFINISHED_DEDUP: 'Please resolve all duplicates',
    ERR_UNMAPPED_ID_FIELD: 'Please map ID field(s): ',
    ERR_UNSUPPORTED_FILE: 'File extension must be one of [csv, xls, xlsx].',
    FAQ: 'FAQ',
    FILE_CAN_BE_IN_FORMAT: 'File can be in Excel or CSV format.',
    HEADER_MAPPING_EMPTY_MESSAGE: 'No headers to display',
    HEADER_MAPPING_EMPTY_TITLE: 'No resources',
    HEADER_MAPPING_TABLE_HEADERS: {
        EXPECTED_SCHEMA: 'Expected schema',
        FILE_HEADER: 'File header',
        MEASUREMENT: 'Units of measurement',
        OVERWRITE_RECORDS: 'Overwrite existing records?',
    },
    IMPORT_PORTFOLIO_DATA_HEADER: 'Import portfolio data',
    IMPORT_WIZARD_TITLE: 'Import',
    INVALID_DATA_MODAL_MESSAGE: {
        ALERT_MESSAGE_GENERAL: 'The file you are importing has the following invalid value(s) in the data set.',
        ALERT_MESSAGE_HINT: 'If you expect the data to be valid, please correct the issue in the data file and restart the data ingestion process. ' +
         'Proceeding will cause the invalid values to be treated as if there were no value present.',
        CANCEL_BUTTON: 'Cancel Import',
        COLUMN_LABEL: 'Column:',
        CONTINUE_BUTTON: 'Acknowledge and Proceed',
        COUNT_LABEL: 'Count:',
        MODAL_HEADER: 'Invalid Values',
    },
    INVALID_FILE: 'File is empty or invalid',
    MANDATORY_HEADERS_TITLE: 'Recommended header mapping',
    MANDATORY_HEADERS_TOOLTIPS: {
        CPU: 'MPA assumes a value of 1 for the corresponding attribute if the number of processors (CPU-Number of Processors), ' +
            'or the number of cores per CPU (CPU-Cores per Processor), '
            + 'or the number of threads per core (CPU-Number of Threads per CPU-Core) is not provided. ' +
            'For finding the best AWS match, MPA computes the total of the number of '
            + 'processors multipled by the number of cores per CPU multipled by the number of threads per core. ' +
            'For Physical servers, MPA also multiplies the result by 2 in order to '
            + 'account for the fact that physical CPUs are generally more powerful than virtual threads.',
        HEADER: 'Header Mapping is an important step and can\'t be changed later. Please take a moment to validate the mapping.',
        HIGHLY_RECOMMENDED: 'OS Name, CPU (Processors), Cores (Per Processor), Ram, Peak CPU Utilization, Peak Ram Utilization, ' +
            'Server Usage %, Physical/Virtual, Server Usage (Uptime), Storage Total Disk Size, and Storage Utilization are highly ' +
            'recommended for TCO analysis. Whenever these fields are not provided, TCO will use industry standard values.',
        PHYSICAL_VIRTUAL: 'Map Physical/Virtual attribute if your portfolio consists of '
        + 'physical and virtual servers. \'Physical\' is the default value for the server.',
        UOM: 'Select correct Unit of Measurement (TB, GB, MB, KB, or Byte) for Storage and Memory attributes, and (Ratio, Percentage) ' +
            'for utilization attributes. UofM should be available in the input file, or check with customer.',
    },
    MISSING_DATA_MESSAGE: {
        WARNING_HEADER: 'Warning: Rows skipped due to blank IDs',
        WARNING_MESSAGE_MULTI_ROW: ' rows of data have been skipped: No. ',
        WARNING_MESSAGE_PART_TWO: 'Often this is due to empty IDs in excel files; please review the file, make updates and re-import if needed.',
        WARNING_MESSAGE_SINGLE_ROW: ' row of data has been skipped: No. ',
    },
    NEXT_BUTTON: 'Next',
    OPTIONAL_HEADERS_TITLE: 'Optional header mapping',
    OPTIONAL_HEADERS_TOOLTIPS: {
        OS: 'Most of portfolio data has OS Version embedded in OS Name. Please map OS Version, ' +
            'in case OS Version is not part of OS Name for correct migration strategy recommendation.',
        TARGET_HOST_TYPE: 'Map Server Target Host Type to assign specific host types to virtual servers. ' +
            'You can modify host type configuration in TCO assessment later. Default host types have the following configuration:',
        TARGET_HOST_TYPES: {
            TYPE_1: 'type1: CPU Subscription Ratio: 1, Ram Subscription Ratio: 1, Hyperthread: 2, Processors: 2, Cores: 8, Ram: 200',
            TYPE_2: 'type2: CPU Subscription Ratio: 1, Ram Subscription Ratio: 1, Hyperthread: 2, Processors: 4, Cores: 16, Ram: 1920',
        },
        UOM: 'Select correct Unit of Measurement (TB, GB, MB, KB, or Byte) for Storage and Memory attributes and ' +
            '(Ratio, Percentage) for utilization attributes. UofM should be available in the input file, or check with customer.',
    },
    OVERWRITE: 'Overwrite',
    OVERWRITE_MODAL_TABLE_HEADERS: {
        FILE_VALUE: 'Uploaded value',
        PORTFOLIO_VALUE: 'Existing value',
    },
    OVERWRITE_MODAL_TITLE: 'Overwrite comparison preview',
    PERCENTAGE_LABEL: 'Percentage (0.00 - 100.00)',
    PREVIOUS_BUTTON: 'Previous',
    RECORDS: 'record(s)',
    REFER_TO_FAQ: 'For more information on type of files and supported data attributes, please refer to ',
    RESOURCE_TYPE_LABELS: {
        APPLICATION: 'Applications',
        APPLICATION_DEPENDENCY: 'Application dependency',
        DATABASE: 'Databases',
        DATABASE_TO_APPLICATION: 'Database to application',
        SERVER: 'Servers',
        SERVER_COMMUNICATION: 'Server communication',
        SERVER_TO_APPLICATION: 'Server to application',
    },
    SAMPLE_FILES_LINK: 'Sample files',
    SELECT_DATA_TYPE_HEADER: 'Select data type',
    SHOW_MAPPED_LABELS: {
        ALL: 'All',
        MAPPED: 'Mapped',
        UNMAPPED: 'Unmapped',
    },
    SUCCESS_IMPORT_MESSAGE: 'Successfully imported {0} {1} record(s).',
    TEMPLATE_FILES_LINK: 'template files',
    UPLOAD_LOCAL_FILE_BUTTON: 'Upload local file',
    VIEW_ONLY_DIFFERENCES_TOGGLE: 'View only differences',
    WIZARD_CANCEL_FRICTION_MODAL_CONTENT: 'Your import of this file will be canceled and none of the data will be saved. Do you want to continue?',
    WIZARD_CANCEL_FRICTION_MODAL_TITLE: 'Cancel import flow',
    WIZARD_STEP_LABELS: {
        DUPLICATE_RECORDS: 'Resolve duplicates',
        HEADER_MAPPING: 'Header mapping',
        PREVIEW: 'Preview',
        SELECT_SHEET: 'Select sheet',
    },
};
